<main>
    <span class="close" (click)="toolServ.hideArticle()"></span>
    <section [style.background-color]="mServ.menu.couleurDroite.code">
        <h1>{{ infos.titre }}</h1>
        <img *ngIf="infos.media" [src]="infos.media" title="infos.titre" />
        <article [innerHtml]="infos.contenu | mark ">
        </article>
        <img *ngIf="infos.mediaplus" [src]="infos.mediaplus" title="infos.titre" />
    </section>
</main>